import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  fillRule: "evenodd",
  d: "M11.79 5.21H6a3 3 0 0 0-3 3v6.016A2.774 2.774 0 0 0 5.774 17h6.016a3 3 0 0 0 3-3V8.21a3 3 0 0 0-3-3M7 5.92h3.8v6.736a.3.3 0 0 1-.49.232L8.9 11.734l-1.41 1.154a.3.3 0 0 1-.49-.232z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14 4.4H8.21A1.6 1.6 0 0 0 6.61 6h-1.4a3 3 0 0 1 3-3H14a3 3 0 0 1 3 3v5.79a3 3 0 0 1-3 3v-1.4a1.6 1.6 0 0 0 1.6-1.6V6A1.6 1.6 0 0 0 14 4.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.79 6.61H6a1.6 1.6 0 0 0-1.6 1.6v6.016c0 .759.615 1.374 1.374 1.374h6.016a1.6 1.6 0 0 0 1.6-1.6V8.21a1.6 1.6 0 0 0-1.6-1.6m0-1.4H6a3 3 0 0 0-3 3v6.016A2.774 2.774 0 0 0 5.774 17h6.016a3 3 0 0 0 3-3V8.21a3 3 0 0 0-3-3",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.3 5.92a.7.7 0 0 1 .7-.7h3.8a.7.7 0 0 1 .7.7v6.736a1 1 0 0 1-1.633.774l-.967-.791-.967.79a1 1 0 0 1-1.633-.773zm1.4.7v5.192l.757-.62a.7.7 0 0 1 .886 0l.757.62V6.62z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=CollectionMultiIcon20.js.map